let threadIdCancel: string | undefined

export const setThreadIdCancel = (value?: string) => {
  threadIdCancel = value
}

export const getThreadIdCancel = () => threadIdCancel
